import {ContentContainer} from '../styles';
import PageTitle from '../../components/PageTitle';
import {EAppMode, ELanguage} from '@microfrontends/react-components';
import dynamic from 'next/dynamic';
import React, {ComponentType} from 'react';
import ActionButton from "../../components/ActionButton";
// TODO - server-side rendering cause podcast styled caching issue
const DynamicPodcastSection: ComponentType<any> = dynamic(() => import('@microfrontends/react-components').then(module => module.Podcast), {ssr: false})
const PodcastSection = ({podcastData}: {podcastData}) => <ContentContainer narrowedWidth>
	<PageTitle id="podcast-danh-cho-fresher">
		Podcast dành cho fresher
	</PageTitle>
	<DynamicPodcastSection
		type={'large' as any}
		language={ELanguage.VI}
		appMode={process.env.APP_SHELL_MODE as EAppMode}
		podcastData={podcastData}
	/>
	<div style={{display: 'flex', justifyContent: 'center', margin: '25px 0'}}>
		<ActionButton variant='orange' href={`${process.env.APP_BASE_URL}/hrinsider/podcast`} target="_blank">
			Tìm hiểu thêm
		</ActionButton>
	</div>
</ContentContainer>

export default PodcastSection
